import React, { useState } from 'react';
import whatsappIcon from '~/assets/images/icons/whatsapp.png';
import { MdClose } from 'react-icons/md';

import { Link, Img, Container, CloseIcon } from './styles';

const whatsappNumber = '1140030267';

const Chatbot = (props) => {
  const [showChatbot, setShowChatbot] = useState(true);
  const isMobile = window.screen.width < 771;
  const whatsappUrl = isMobile
    ? `https://wa.me/${whatsappNumber}`
    : `https://web.whatsapp.com/send?phone=${whatsappNumber}`;

    const handleClickClose = () => {
      setShowChatbot(false);
      localStorage.setItem('chatbotClosed', 'true');
    }

    const isChatbotClosed = () => {
      return localStorage.getItem('chatbotClosed') === 'true';
    }

  return (
    <>
    {showChatbot && !isChatbotClosed() && (
      <Container props={props}>
        <CloseIcon onClick={handleClickClose}>
          <MdClose />
        </CloseIcon>
        <Link
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fale conosco pelo WhatsApp"
          >
          <Img
            src={whatsappIcon}
            alt="WhatsApp"
            />
        </Link>
      </Container>
      )}
    </>
  );
}


export default Chatbot;
